/**
 * Removes the named cookie by setting it's max age effectively to 0.
 *
 * @param {String} name The name of the cookie.
 * @return {void}
 */
export function removeCookie(name: string): void {
    document.cookie = `${name}=;Max-Age=-99999999;`;
}
